import { useState } from "react";
import { toast } from "sonner";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { api, formatApiErrorDetail } from "../lib/api";

const services = [
  "Drama Coaching",
  "LAMDA Exam Prep",
  "Voice & Communication",
  "Drama School Prep",
  "Mind's Chaos (theatre in education show)",
  "Not sure yet",
];

export default function Contact() {
  const [form, setForm] = useState({
    name: "", email: "", phone: "", service: services[0], preferred_date: "", message: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/contact", form);
      setDone(true);
      toast.success("Message sent. Thank you!");
      setForm({ name: "", email: "", phone: "", service: services[0], preferred_date: "", message: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not send message.");
    } finally {
      setSubmitting(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border-b border-[#1A1A1A]/20 py-3 text-[#1A1A1A] placeholder-[#737373] focus:outline-none focus:border-[#7A1C28] transition-colors";

  return (
    <div>
      <Navbar />
      <section className="max-w-7xl mx-auto px-6 md:px-12 pt-36 pb-24 grid grid-cols-1 md:grid-cols-2 gap-16">
        <div>
          <p className="label-caps text-[#7A1C28] mb-4">Get in touch</p>
          <h1 className="font-serif-display text-5xl sm:text-6xl font-light leading-tight mb-6">
            Book a session or ask a question.
          </h1>
          <p className="text-[#4A4A4A] leading-relaxed mb-8 max-w-md">
            Tell me a little about what you're looking for, whether an exam, an audition,
            voice work or speech support, and I'll get back to you to arrange a time.
          </p>
          <div className="space-y-2 text-sm text-[#4A4A4A]">
            <p><span className="label-caps text-[0.65rem] text-[#7A1C28] mr-2">Sessions</span> In-person &amp; online</p>
            <p><span className="label-caps text-[0.65rem] text-[#7A1C28] mr-2">Remote coaching</span> £25 per hour</p>
          </div>
        </div>

        <div className="bg-[#FFFFFF] border border-[#E5E2D9] p-8 md:p-10">
          {done ? (
            <div data-testid="contact-success" className="py-12 text-center">
              <h3 className="font-serif-display text-3xl mb-3">Thank you!</h3>
              <p className="text-[#4A4A4A]">Your message has been received. I'll be in touch soon.</p>
              <button data-testid="send-another-button" onClick={() => setDone(false)} className="mt-6 label-caps text-[0.7rem] text-[#7A1C28]">
                Send another
              </button>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-6" data-testid="contact-form">
              <div>
                <label className="label-caps text-[0.65rem] text-[#737373]">Name</label>
                <input data-testid="contact-name-input" required value={form.name} onChange={update("name")} className={inputCls} placeholder="Your full name" />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <label className="label-caps text-[0.65rem] text-[#737373]">Email</label>
                  <input data-testid="contact-email-input" type="email" required value={form.email} onChange={update("email")} className={inputCls} placeholder="you@email.com" />
                </div>
                <div>
                  <label className="label-caps text-[0.65rem] text-[#737373]">Phone (optional)</label>
                  <input data-testid="contact-phone-input" value={form.phone} onChange={update("phone")} className={inputCls} placeholder="+44 …" />
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <label className="label-caps text-[0.65rem] text-[#737373]">Service</label>
                  <select data-testid="contact-service-select" value={form.service} onChange={update("service")} className={inputCls}>
                    {services.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
                <div>
                  <label className="label-caps text-[0.65rem] text-[#737373]">Preferred date</label>
                  <input data-testid="contact-date-input" type="date" value={form.preferred_date} onChange={update("preferred_date")} className={inputCls} />
                </div>
              </div>
              <div>
                <label className="label-caps text-[0.65rem] text-[#737373]">Message</label>
                <textarea data-testid="contact-message-input" required rows={4} value={form.message} onChange={update("message")} className={inputCls} placeholder="Tell me about your goals…" />
              </div>
              <button data-testid="contact-submit-button" type="submit" disabled={submitting} className="w-full bg-[#7A1C28] text-white hover:bg-[#5C151E] transition-colors px-8 py-4 label-caps text-[0.7rem] disabled:opacity-60">
                {submitting ? "Sending…" : "Send Booking Request"}
              </button>
            </form>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
}
